import { render, staticRenderFns } from "./columnCard.vue?vue&type=template&id=1956442a&scoped=true&"
import script from "./columnCard.vue?vue&type=script&lang=js&"
export * from "./columnCard.vue?vue&type=script&lang=js&"
import style0 from "./columnCard.vue?vue&type=style&index=0&id=1956442a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956442a",
  null
  
)

export default component.exports